import { render, staticRenderFns } from "./PageMobile.vue?vue&type=template&id=77c7df6c"
import script from "./PageMobile.vue?vue&type=script&lang=ts"
export * from "./PageMobile.vue?vue&type=script&lang=ts"
import style0 from "./PageMobile.vue?vue&type=style&index=0&id=77c7df6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports